module.exports = __webpack_public_path__ + "static/avatar-7e24402418bd472dd27a3bb95c2e4702.png";